import React from 'react'
import { Tag } from 'antd'
import { Theme } from 'Components/common'
import styled from 'styled-components'

type Props = {
  isReturn?: boolean
  returnQty?: number
  isText?: boolean
  returnUom: string
}

const ReturnTag = (props: Props) => {
  const { isReturn = false, isText = false, returnQty = 0, returnUom = '' } = props
  return isText ? (
    <TagMessage color={'red'} visible={isReturn}>
      คืนเงิน/คืนสินค้า {returnQty > 0 && `${returnQty} ${returnUom}`}
    </TagMessage>
  ) : (
    <TagWrapper color={'red'} visible={isReturn}>
      คืนเงิน/คืนสินค้า {returnQty > 0 && `${returnQty} ${returnUom}`}
    </TagWrapper>
  )
}

const TagMessage = styled(Tag)`
  font-size: 10px;
  padding: 0 5px;
  line-height: 16px;
  margin-top: 5px;
`

const TagWrapper = styled(Tag)`
  border-radius: 15px;
  max-width: 100%;
`

export default ReturnTag
